import { Send } from "lucide-react";
import useSWR from "swr";
import { useTranslation } from "react-i18next";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL, getQueryString } from "@utils/utilsApi";
import {
  AlertContainer,
  CounterBox,
  CounterText,
  DescriptionContainer,
  TitleContainer,
} from "./style";

interface CalendarCount {
  account_type: string;
  sent_calendars: number;
  max_calendars: number;
  queued_calendars: number;
}

interface TeamsLimitAlertCstProps {
  corporateId?: string;
}

const TeamsLimitAlertCst: React.FC<TeamsLimitAlertCstProps> = ({
  corporateId,
}) => {
  const { t } = useTranslation(["teams-limit-alert"]);

  const url = corporateId
    ? getQueryString(ServicesURL.getCalendarsCount, {
        corporateId,
        accountType: "MSTEAMS",
      })
    : null;

  const { data } = useSWR(url ? [url, MethodType.GET] : null, ([u, method]) =>
    fetcher(u, method),
  );

  const counts: CalendarCount | undefined = data?.output?.find(
    (c: CalendarCount) => c.account_type === "MSTEAMS",
  );

  if (!counts) return null;

  const max = counts.max_calendars ?? 0;
  const sent = counts.sent_calendars ?? 0;
  const queued = counts.queued_calendars ?? 0;
  const available = Math.max(0, max - sent);

  return (
    <AlertContainer severity="info" variant="outlined">
      <TitleContainer>{t("title")}</TitleContainer>
      <DescriptionContainer variant="body2">
        {t("description", { max })}
      </DescriptionContainer>
      <CounterBox>
        <Send size={16} style={{ marginRight: 8 }} />
        <CounterText variant="body2">
          {t("counter", { available, max, queued })}
        </CounterText>
      </CounterBox>
    </AlertContainer>
  );
};

export default TeamsLimitAlertCst;
